<template>
  <b-button-group>
    <b-button @click="onArrowUpClick" variant="flat-secondary" size="sm"><i class="fas fa-arrow-up"></i></b-button>
    <b-button @click="onArrowDownClick" variant="flat-secondary" size="sm"><i class="fas fa-arrow-down"></i></b-button>
    <b-button @click="onRemoveClick" variant="flat-secondary" size="sm"><i class="fas fa-trash"></i></b-button>
  </b-button-group>
</template>

<script>
import { BButton, BButtonGroup} from "bootstrap-vue";

export default {
   methods: {
       onArrowUpClick(){
           this.$emit('on-arrow-up-click');
       },
       onArrowDownClick(){
           this.$emit('on-arrow-down-click');
       },
       onRemoveClick(){
           this.$emit('on-remove-click');
       }
   },
   components: {
       BButton,
       BButtonGroup
   }
};
</script>

<style>
</style>